import { faPlus, faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Button, Table, Dropdown } from 'react-bootstrap';
import { COLOR_APP } from '../../../constants';
import { imageRender } from '../../../helpers';
import PaginationsV1 from '../../../components/PaginationV1';
import { errorSwal } from '../../../helpers/sweetalert';

export default function AllProduct({ userStockLoading, liveStock, products, checkStockIsAdded, addStockToLive, setLiveStock, stockTotal, page, pageAll, handleChangePage, perPageLimit, handlePerPageChange }) {

    const onSeletedAllStocks = async () => {
        let _stockList = [...liveStock]
        for (var i = 0; i < products.length; i++) {
            _stockList.push({
                stock: products[i],
                amount: products[i].amount,
                amountAll: products[i].amount,
                validateAmount: 0,
                cfMessage: products[i]?.cfMessage ?? "",
                name: products[i]?.name,
            })
        }
        setLiveStock(_stockList)
    }

    if (userStockLoading) return <div style={{ display: 'flex', flexDirection: "column", width: '100%', marginTop: 32, justifyContent: 'center', alignItems: 'center' }}>
        <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
        </div>
    </div>

    return (
        <div style={{ display: 'flex', flexDirection: "column", width: '100%', marginTop: 10 }}>
            <div style={{ display: 'flex', width: '100%', justifyContent: "start", flexDirection: 'column' }}>

                <div className='d-flex justify-content-between w-100 gap-2 mb-2'>
                    <Button onClick={onSeletedAllStocks} style={{ fontSize: 12, height: 35, background: COLOR_APP, color: "#fff", border: "none" }}>ເພີ່ມທັ້ງໝົດ</Button>
                    <Dropdown>
                        <Dropdown.Toggle variant="light" id="dropdown-basic">
                            ສະແດງ {perPageLimit}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => handlePerPageChange(150)}>150/ໜ້າ</Dropdown.Item>
                            <Dropdown.Item onClick={() => handlePerPageChange(800)}>800/ໜ້າ</Dropdown.Item>
                            <Dropdown.Item onClick={() => handlePerPageChange(1000)}>1000/ໜ້າ</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <PaginationsV1
                    count={stockTotal}
                    perPageLimit={perPageLimit}
                    page={page}
                    pageAll={pageAll}
                    onPageChange={handleChangePage}
                    textNext=">"
                    textPrev="<"
                />
            </div>
            <div>
                <Table
                    responsive
                    style={{
                        marginTop: "20px",
                        borderCollapse: "collapse",
                        width: "100% ",
                    }}>
                    <thead >
                        <tr style={{ whiteSpace: 'nowrap' }}>
                            <th style={{ borderBottom: "none" }}>ຮູບ</th>
                            <th style={{ borderBottom: "none" }}>ຊື່ສິນຄ້າ</th>
                            <th style={{ borderBottom: "none" }}>ຈໍານວນ</th>
                            {/* <th style={{ borderBottom: "none" }}>ສະຖານະ</th> */}
                            <th style={{ borderBottom: "none" }}>ລາຄາ</th>
                            <th style={{ borderBottom: "none" }}>ຈັດການ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {products.length > 0 && products.map((stock, index) =>
                            <tr key={stock + index}>
                                <td>
                                    <img src={imageRender(stock?.image)} style={{
                                        borderRadius: 5,
                                        height: 60,
                                        width: 60,
                                    }} />
                                </td>
                                <td>{stock?.name} {stock?.cfMessage ?? ""}</td>
                                <td>{stock?.amount ?? ""} {stock?.unit ?? ""}</td>
                                <td>{new Intl.NumberFormat("en-US").format(stock?.price ?? 0)} {stock?.currency ?? ""}</td>
                                <td>{checkStockIsAdded(stock) ? <div disabled style={{ width: 35, height: 35, borderRadius: 8, background: "#ebebeb", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginRight: 10 }}>
                                    <FontAwesomeIcon icon={faPlus} style={{ color: "white", fontSize: 20 }} />
                                </div> : <div onClick={() => addStockToLive(stock)} style={{ width: 35, height: 35, borderRadius: 8, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginRight: 10 }}>
                                    <FontAwesomeIcon icon={faPlus} style={{ color: "green", fontSize: 20 }} />
                                </div>}</td>
                            </tr>
                        )}
                    </tbody>
                </Table>

            </div>
        </div>
    )
}
